import { render, staticRenderFns } from "./PlaceButton.vue?vue&type=template&id=68b99d51&"
import script from "./PlaceButton.vue?vue&type=script&lang=js&"
export * from "./PlaceButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports